"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SkeletonProps = require("./SkeletonProps");
Object.keys(_SkeletonProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SkeletonProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SkeletonProps[key];
    }
  });
});
